module.exports = __webpack_public_path__ + "static/gone-girl-7f0182b312b12462d38aaa8a1083b64a.jpg";